/**
 * NotificationRowSkeleton — loading placeholder for a single notification row.
 *
 * Three instances are shown while GET /api/v1/notifications is in flight.
 * Rows are aria-hidden — the parent dialog sets aria-busy="true" while loading.
 */

import React from 'react';

export function NotificationRowSkeleton() {
  return (
    <div
      className="flex items-start gap-2 px-4 py-3 border-b border-hairline"
      aria-hidden="true"
    >
      <span className="w-1.5 h-1.5 rounded-full bg-gray-200 animate-pulse mt-1.5 flex-shrink-0" />
      <span className="flex-1 flex flex-col gap-2">
        <span className="flex gap-2">
          <span className="h-4 w-28 bg-gray-200 animate-pulse rounded" />
          <span className="h-3 w-10 bg-gray-200 animate-pulse rounded ml-auto" />
        </span>
        <span className="h-3 w-40 bg-gray-200 animate-pulse rounded" />
      </span>
    </div>
  );
}
